// extracted by mini-css-extract-plugin
export default {"nftSellOfferItem":"OdafXnHNfwmh1ucytGJP","nftSellOfferItemPrice":"Lc3bmrpm3DAE4ABsW7dH","nftSellOfferItemLogo":"nfelGI6EqiMHgybSdHx7"};